var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import colors from "./colors";
import * as constants from "../default/constants";
var root = {
    name: "Dark",
    version: "0.0.1",
};
export var DarkTheme = __assign(__assign({}, root), { constants: constants,
    colors: colors });
